import {UserAlertsError} from './UserAlertsError.js'

const ERROR_CODE_DUPLICATED_ALERT = 409

export class DuplicatedUserAlertError extends UserAlertsError {
  constructor({notAvailableFilters, message}) {
    super({message})
    this._notAvailableFilters = notAvailableFilters
    this._message = message
  }

  getError = () => {
    return {
      notAvailableFilters: this._notAvailableFilters,
      message: this._message,
      code: ERROR_CODE_DUPLICATED_ALERT
    }
  }
}
